import * as React from 'react';
import * as ReactDOM from 'react-dom';
import Modal from 'react-modal';
import {RouteManager} from "appRoot/RouteManager";

// Hot Module Replacement
declare let module: { hot: any };

const rootEl = document.getElementById('diaryRoot');
Modal.setAppElement(rootEl);

ReactDOM.render(
  <React.StrictMode>
    <RouteManager />
  </React.StrictMode>,
  rootEl
);

if (module.hot) {
  module.hot.accept('./RouteManager', () => {
    const HotRouteManager = require('./RouteManager').default;
    ReactDOM.render(
      <React.StrictMode>
        <HotRouteManager />
      </React.StrictMode>,
      rootEl
    );
  });
}
